function Ctrl($scope, partnerService, modalService) {
  $scope.partner = partnerService.partner;

  $scope.enterPromo = function() {
    modalService.enterPromo();
  };

  $scope.openSearchModal = function() {
    modalService.search();
  };
}

Ctrl.$inject = [
  '$scope',
  'partnerService',
  'modalService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/appFooter/controller.js